const identity = (...args: $TSFixMe[]) => args[0];

export default ({ parentSelector = identity, initialState = {}, scopeName = 'scope' } = {}) =>
    (state: $TSFixMe, props: $TSFixMe) => {
        const parentState = parentSelector(state, props);
        const scope = props && props[scopeName];
        return (parentState && parentState[scope]) || initialState;
    };
